export const categoryIcons = [
     'fastfood', 'home',  'tv', 'headphones', "blender", "book", "brush", "chair"
]